import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconArrowRight } from '@redteclab/icons'

import { Button } from 'base-ui'

import { productSearchAlgoliaAccessorGetOffersData } from '../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorGetOffersData'
import { productSearchAlgoliaAccessorGetVariantsData } from '../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorGetVariantsData'
import { ProductSearchFlag } from '../ProductSearchFlag'

import { useProductSearchResultItemContext } from './ProductSearchResultItemContext/productSearchResultItemContext'

export const ProductSearchResultItemProductLinkWithIcon: FC = () => {
  const { algoliaRecord, isMarketplace, onProductClick, query } =
    useProductSearchResultItemContext()
  const { productHasMultipleVariants } =
    productSearchAlgoliaAccessorGetVariantsData(algoliaRecord)
  const productSellerCount = algoliaRecord.seller_count

  const {
    hasNonBestOfferSellerPromotion,
    productUrl,
    shouldDisplayLinkToOfferPage,
  } = productSearchAlgoliaAccessorGetOffersData(
    algoliaRecord,
    isMarketplace,
    query,
  )

  return (
    <>
      {productHasMultipleVariants ? (
        <Button<'a'>
          className="z-10"
          endIcon={<IconArrowRight />}
          href={productUrl}
          onClick={onProductClick}
          size="medium"
          variant="text"
        >
          <FormattedMessage id="product.variants.configure.link" />
        </Button>
      ) : null}

      {shouldDisplayLinkToOfferPage ? (
        <>
          {hasNonBestOfferSellerPromotion ? (
            <ProductSearchFlag
              className="bg-light-tertiary"
              data-qa-id="serp-has-non-best-offer-seller-promotion-label"
            >
              <FormattedMessage id="seller.promotion.product.badge" />
            </ProductSearchFlag>
          ) : null}
          <Button<'a'>
            className="z-10"
            endIcon={<IconArrowRight />}
            href={productUrl}
            onClick={onProductClick}
            size="medium"
            variant="text"
          >
            <FormattedMessage
              id="product.seller.count"
              values={{ count: productSellerCount }}
            />
          </Button>
        </>
      ) : null}
    </>
  )
}
